// src/pages/admin/editorTabs/TabsBar.jsx
import React from "react";

function TabBtn({ active, onClick, icon, label }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "flex-1 px-3 py-2 rounded-xl border text-sm font-medium transition-all",
        active
          ? "bg-gray-900 text-white border-gray-900"
          : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50",
      ].join(" ")}
    >
      <span className="mr-2">{icon}</span>
      {label}
    </button>
  );
}

export default function TabsBar({ value, onChange }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border p-2">
      <div className="flex gap-2">
        <TabBtn active={value === "users"} onClick={() => onChange("users")} icon="👤" label="Users" />
        <TabBtn active={value === "general"} onClick={() => onChange("general")} icon="⚙️" label="General" />
        <TabBtn active={value === "editor"} onClick={() => onChange("editor")} icon="🧩" label="Editor" />
        <TabBtn active={value === "limits"} onClick={() => onChange("limits")} icon="🚦" label="Limits" />
      </div>
    </div>
  );
}